// src/admin/Clients/activity_notes/ActivityTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import CareMagnusTable from "../../../utils/CareMagnusTable";
import { httpAdmin } from "../../../Apis/commonApis";
import { Dropdown, DropdownButton } from "react-bootstrap";
import ActivityFormModel from "./ActivityFormModel";
import {
  formatDateToDDMMYYYY,
  getFullName,
} from "../../../utils/CommonFunctions";
import { ShowSwal } from "../../../utils/alertSwal";
import { BsSearch } from "react-icons/bs";
import { filterData } from "../../../utils/TableSearchFilter";
import swal from "sweetalert";

function ActivityTable({ clientId }) {
  const [activityData, setActivityData] = useState([]);
  const [openActivityModal, setActivityModal] = useState(false);
  const [editActivityData, setEditActivityData] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [searchText, setSearchText] = useState("");

  const fetchActivityData = async () => {
    const res = await httpAdmin(
      `getClientActivity?clientId=${clientId}`,
      "get",
      null,
      null
    );
    setActivityData(res?.data ?? []);
  };

  useEffect(() => {
    fetchActivityData();
  }, []);

  const columns = [
    {
      field: "category",
      headerName: "Category",
      width: 180,
    },
    {
      field: "activityType",
      headerName: "Activity Type",
      sortable: false,
      disableColumnMenu: true,
      flex: 1,
      width: 120,
    },
    {
      field: "createdAt",
      headerName: "Creation Date",
      flex: 1,
      minWidth: 190,
      valueFormatter: (params) => {
        return `${formatDateToDDMMYYYY(params.value)}`;
      },
    },
    {
      field: "createdBy",
      headerName: "Created By",
      flex: 1,
      minWidth: 150,
      align: "center",
      valueFormatter: (params) => {
        return `${getFullName(params.value)}`;
      },
    },
    {
      field: "notes",
      headerName: "Notes",
      flex: 1,
      minWidth: 140,
    },
  ];

  const handleRowSelection = (selected) => {
    setSelectedRow(selected);
  };

  const handleDelete = async () => {
    if (selectedRow.length === 0) {
      ShowSwal(false, "Please select a row to delete.");
      return;
    }

    swal({
      title: "Are you sure??",
      text: `click on Yes to deleted selected`,
      buttons: {
        cancel: "Cancel",
        succeed: "Yes",
      },
    }).then((result) => {
      if (result) {
        deleteAction();
      } else {
        console.log("rejected");
      }
    });
  };

  const deleteAction = async () => {
    try {
      const res = await httpAdmin(
        `deleteClientActivity`,
        "delete",
        { id: selectedRow },
        null
      );
      ShowSwal(res.status, res.message);
      if (res.status) {
        fetchActivityData();
      }
      setSelectedRow([]);
    } catch (error) {
      console.error("Error deleting activity:", error);
      ShowSwal(false, "Failed to delete activity");
    }
  };

  const handleModalClose = (type) => {
    if (type === "refresh") {
      fetchActivityData();
    }
    setEditActivityData(null);
    setActivityModal(false);
  };

  const handleOpenActivityModal = (type) => {
    if (type === "edit") {
      if (selectedRow.length === 1) {
        const selectedId = selectedRow[0];
        const selected = activityData.find((row) => row._id === selectedId);
        console.log(selected, 'ssssssssssssss')
        setEditActivityData(selected);
        setActivityModal(true);
      } else {
        ShowSwal(false, "Please select one row to edit");
      }
    } else {
      setActivityModal(true);
    }
  };

  const filteredRows = useMemo(() => {
    return filterData(
      columns?.map((item) => ({
        id: item.field,
        label: item.headerName,
      })),
      activityData,
      searchText
    );
  }, [searchText, activityData]);

  return (
    <div>
      <div className="btns_head topButtonShow">
        <div className="searchForm" style={{ width: "50%" }}>
          <input
            type="text"
            className="form-control"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
            }}
            placeholder="Search"
          />
          <BsSearch className="icon me-2" />
        </div>
        <DropdownButton
          id="dropdown-basic-button"
          title="Actions"
          className="d-flex justify-content-end"
        >
          <Dropdown.Item onClick={() => handleOpenActivityModal("add")}>
            Add Activity
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleOpenActivityModal("edit")}
            disabled={selectedRow?.length !== 1}
          >
            Edit Activity
          </Dropdown.Item>
          <Dropdown.Item
            onClick={handleDelete}
            disabled={selectedRow?.length !== 1}
          >
            Delete
          </Dropdown.Item>
        </DropdownButton>
      </div>
      <CareMagnusTable
        tableHeight="calc(100vh - 165px)"
        idParam="_id"
        columns={columns}
        rows={filteredRows}
        selectedRow={selectedRow}
        handleRowSelection={handleRowSelection}
      />
      {openActivityModal && (
        <ActivityFormModel
          openActivityModal={openActivityModal}
          handleModalClose={handleModalClose}
          editActivityData={editActivityData}
          clientId={clientId}
        />
      )}
    </div>
  );
}

export default ActivityTable;
